import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperPlayOrWatchButton: {
        width: "100%",
        display: "grid",
        placeItems: "center",
        position: "relative",
        "&.isMobile": {
            height: "100%",
        },
    },
    button: {
        width: 65,
        height: 40,
        fontSize: 15,
        fontWeight: 700,
        padding: "0 2px",
        textAlign: "center",
        wordBreak: "break-word",
        "&.isMobile": {
            height: "55%",
            fontSize: 12,
            width: "100%",
        },
        "&.cancel": {
            fontSize: 14,
            fontWeight: 600,
        },
        "&.watch": {
            width: 'auto',
            height: 35,
            opacity: "0.7",
            transition: "0.1s transform ease-out",
            transform: "scale(1)",

            "@media (hover: hover)": {
                "&:hover": {
                    transition: "0.15s transform ease-in",
                    transform: "scale(1.2)",
                    cursor: "pointer",
                },
            },
        },
    },
});
